module.exports = __webpack_public_path__ + "static/img/shandongjingmi.fd9e0e20.png";